// @dynamic
export class UiHelper{
  static isWebkitBoxElementEllipsisActive(element, lineClamp: number) {
    const originalHeight = element.style.height;
    const clampedHeight = element.offsetHeight;
    element.style.display = 'block';
    element.style.webkitLineClamp = 'unset';
    const fullHeight = element.offsetHeight;
    element.style.height = originalHeight;
    element.style.webkitLineClamp = lineClamp.toString();
    element.style.display = '-webkit-box';
    return clampedHeight < fullHeight;
  }
}
